import { SplitText } from '../plugins/gsap/SplitText';

export default function ($container, lines = true, words = false, chars = false, linesClass = 'line', wordsClass = 'word', charsClass = 'char', classInnerSuffix = 'inner') {

	/*

	// TODO: COMPLETE

	const splitChars = ($lineChars, $inner) => {
		for (let k = 0; k < $lineChars.length; k++) {
			const $lineChar = $lineChars[k];

			if (words) {
				const $innerChar = document.createElement('div');
				$innerChar.classList.add(`${charsClass}-${classInnerSuffix}`);
				$innerChar.innerHTML = $lineChar.innerHTML;
				$lineChar.innerHTML = '';
				$lineChar.appendChild($innerChar);
			}

			$inner.appendChild($lineChar);
		}
	};

	*/

	const splitWords = ($words, $wordContainer) => {
		for (let k = 0; k < $words.length; k++) {
			const $word = $words[k];

			if (words) {
				const $innerWord = document.createElement('div');
				$innerWord.classList.add(`${wordsClass}-${classInnerSuffix}`);
				$innerWord.innerHTML = $word.innerHTML;
				$word.innerHTML = '';
				$word.appendChild($innerWord);
			}

			if ($wordContainer) {
				$wordContainer.appendChild($word);
				if (k < $words.length - 1) {
					const $space = document.createElement('div');
					$space.classList.add('space');
					$space.setAttribute('style', $word.getAttribute('style'));
					$space.innerHTML = '&nbsp;';
					$wordContainer.appendChild($space);
				}
			}
		}
	};

	// create new SplitText object

	const splitType = [];
	if (chars) { splitType.push('chars'); }
	if (words) { splitType.push('words'); }
	if (lines || !splitType) { splitType.push('lines'); }

	const splitText = new SplitText($container, {
		type: splitType.join(','),
		linesClass,
		wordsClass,
		charsClass
	});

	// TODO: don't add to dom until all children are added to parent

	if (lines) {
		const $lines = splitText.lines;
		for (let i = 0; i < $lines.length; i++) {
			const $line = $lines[i];
			const lineContents = $line.innerHTML;
			const $inner = document.createElement('div');
			$inner.classList.add(`${linesClass}-${classInnerSuffix}`);

			if (splitText.words.length && words) {
				const $lineWords = [...$line.children];
				splitWords($lineWords, $inner);
			} else {
				$line.innerHTML = '';
				$inner.innerHTML = lineContents;
			}

			$line.appendChild($inner);
		}
	}

	if (!lines && words && splitText.words.length) {
		splitWords(splitText.words);
	}

	if (chars && splitText.chars.length) {
		const $words = splitText.words;
		for (let i = 0; i < $words.length; i++) {
			const $word = $words[i];
			const $wordChars = [...$word.children];
			splitWords($wordChars, $word);
		}
	}

	return splitText;
}
